// item 1056 (Chad: "we lose the sticky dash and header — it's scrolling infinitely") —
// element.scrollIntoView() scrolls EVERY scrollable ancestor, including the app shell's
// overflow:hidden viewport lock (item 369a). One call from a section-nav / step link
// nudged the locked shell column, the sticky header slot slid out of view, and nothing
// ever reset it. This helper scrolls exactly ONE container — the element's nearest real
// scrollport (the app's content region, or a layer panel's own scroll area) — and never
// touches the locked shell.
const nearestScrollport = (el: HTMLElement): HTMLElement | null => {
  let p = el.parentElement;
  while (p) {
    const s = window.getComputedStyle(p);
    if (/(auto|scroll)/.test(s.overflowY)) return p;
    p = p.parentElement;
  }
  return null;
};

const scrollContentToEl = (
  el: HTMLElement | null,
  opts?: { behavior?: 'smooth' | 'auto'; block?: 'start' | 'center' },
): void => {
  if (!el) return;
  const port = nearestScrollport(el);
  if (!port) return; // no scrollable ancestor — nothing to do (and nothing to break)
  const pr = port.getBoundingClientRect();
  const er = el.getBoundingClientRect();
  // honor the element's scroll-margin-top (used for sticky-header offsets); read via
  // getPropertyValue — the project's older DOM lib types don't know scrollMarginTop
  const margin = parseFloat(window.getComputedStyle(el).getPropertyValue('scroll-margin-top') || '0') || 0;
  const offset = opts?.block === 'center' ? Math.max(0, (pr.height - er.height) / 2) : margin;
  port.scrollTo({
    top: port.scrollTop + (er.top - pr.top) - offset,
    behavior: opts?.behavior ?? 'smooth',
  });
};

export default scrollContentToEl;
